import styled, { css } from 'styled-components/macro';
import { ControlStyledProps } from './controls.types';

export const ControlWrapper = styled.label<ControlStyledProps>`
  ${({ theme }) => css`
    box-sizing: border-box;
    position: relative;
    display: inline-flex;
    cursor: pointer;
    transition-duration: ${theme.tokens.animation.duration.base};

    &:has(input:disabled) {
      cursor: not-allowed;
    }

    &:has(input:focus-visible) {
      box-shadow: 0 0 0 4px ${theme.semantic.focus.ringNeutral};
    }

    &:has(input:is(:checked, :indeterminate)):has(input:focus-visible) {
      box-shadow: 0 0 0 4px ${theme.semantic.focus.ringAccent};
    }
  `}
`;

export const HiddenInput = styled.input`
  position: absolute;
  inset: 0;
  opacity: 0;
  outline: none;
  cursor: inherit;
  margin: 0;
`;
